import { TooltipProvider, TooltipRoot, TooltipTrigger } from 'reka-ui'

export { default as TooltipContent } from './TooltipContent.vue'
export { TooltipRoot as Tooltip, TooltipProvider, TooltipTrigger }

export const TOOLTIP_CONTENT_BASE_CLASS =
  'tw-z-50 tw-overflow-hidden tw-rounded-md tw-border tw-border-border tw-bg-popover tw-px-3 tw-py-1.5 tw-text-md tw-text-popover-foreground tw-shadow-md'

export const TOOLTIP_SIDE_DATA_CLASS =
  'data-[state=delayed-open]:data-[side=top]:tw-slide-in-from-bottom-2 data-[state=delayed-open]:data-[side=right]:tw-slide-in-from-left-2 data-[state=delayed-open]:data-[side=bottom]:tw-slide-in-from-top-2 data-[state=delayed-open]:data-[side=left]:tw-slide-in-from-right-2 data-[state=delayed-open]:tw-animate-in data-[state=delayed-open]:tw-fade-in-0 data-[state=delayed-open]:tw-zoom-in-95'

export const TOOLTIP_SIDE_CLASS = {
  top: 'tw-origin-bottom tw-animate-in tw-fade-in-0 tw-zoom-in-95 tw-slide-in-from-bottom-2',
  right:
    'tw-origin-left tw-animate-in tw-fade-in-0 tw-zoom-in-95 tw-slide-in-from-left-2',
  bottom:
    'tw-origin-top tw-animate-in tw-fade-in-0 tw-zoom-in-95 tw-slide-in-from-top-2',
  left: 'tw-origin-right tw-animate-in tw-fade-in-0 tw-zoom-in-95 tw-slide-in-from-right-2',
}

export const TOOLTIP_ARROW_SIZE = 8

export const TOOLTIP_ARROW_CLASS =
  'tw-absolute tw-h-2 tw-w-2 tw-rotate-45 tw-border-b tw-border-r tw-border-border tw-bg-popover'
